import { fetchApi } from '@/config/axiosSetting.ts';
import {
  getIncidentDetailsInitialQueryPropsType,
  IncidentDetailsInitialResponseType,
} from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/initial/getIncidentDetailsInitialQuery.types';

const getIncidentDetailsInitialQuery = ({
  id,
}: getIncidentDetailsInitialQueryPropsType): Promise<IncidentDetailsInitialResponseType> => {
  return fetchApi({
    method: 'GET',
    url: `/initial/reports/${id}/visit_information/`,
  });
};

export default getIncidentDetailsInitialQuery;
